<template>
  <div class="p-4 radius">
    <div class="mb-4  ">
      <svg xmlns="http://www.w3.org/2000/svg" width="40" height="38" viewBox="0 0 40 38" fill="none" style="cursor: pointer;" @click="goBack()">
        <path d="M38.75 19.0003H1.25M1.25 19.0003L18.9583 1.29199M1.25 19.0003L18.9583 36.7087" stroke="#FF7C48" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
      </svg>
    </div>
    <div class="d-flex justify-content-between" style="margin-bottom: 1.70rem;">
      <div class="d-flex align-items-center" style="gap: 2.34rem;">
        <div>
          <h1 class="title">{{ header }}</h1>
        </div>
      </div>
      <div v-if="survey.status != 'DONE'" class="d-flex align-items-center" @click="createSurveyParticipant()">
        <div class="new-task-text">{{ $t("file-approval-survey.member.create") }}</div>
        <div class="plus-button" style="margin-right: 1.56rem;"></div>
      </div>
    </div>
    <right-panel class="float-right" id="sidebar-survey-participant" width="400px" @hidden="rightPanelClosed">
      <div class="pl-5 pr-5">
        <Form :hide-library="true" @onSave="fetchSurveyMembers" />
      </div>
    </right-panel>
    <!-- <b-modal id="invite-member" :title="$t('organization.invite')">
      <organization-invite-member :disableRoles="true" :organization="currentOrganization" @closeForm="fetchSurveyMembers()" />
    </b-modal> -->
    <table class="table table project-list-table compact">
      <thead>
        <tr>
          <th></th>
          <th style="width:100px">No</th>
          <th style="width:300px">{{ $t("common.name") }}</th>
          <th style="width:300px">{{ $t("asset-group-survey.member.title") }}</th>
          <th style="width:300px">{{ $t("asset-group-survey.member.unit") }}</th>
          <th style="width:300px">{{ $t("asset-group-survey.member.contact") }}</th>
          <th>{{ $t("asset-group-survey.member.date") }}</th>

          <th style="width: 15%">
            <a href="javascript:;" @click="toggleFilter">
              <span v-if="filterEnabled" class="text-warning">
                <i class="bx bxs-filter-alt"></i>
                {{ $t("common.filters-hide") }}
              </span>
              <span v-else class="text-muted">
                <i class="bx bxs-filter-alt"></i>
                {{ $t("common.filters-show") }}
              </span>
            </a>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-if="filterEnabled">
          <th></th>
          <th></th>
          <th></th>
          <th></th>
          <th></th>
          <th></th>
          <th></th>
        </tr>
        <template v-if="memberPagination">
          <tr class="hider" v-for="(item, index) in memberPagination.docs" :key="item._id">
            <td>
              <div class="hidden hand">
                <a v-if="survey.status != 'DONE'" @click="edit(item)" v-b-toggle="'sidebar-edit-organization-datasource'" v-b-tooltip.hover :title="$t('common.edit')" class="mr-2">
                  <i class="bx bx-pencil text-primary"></i>
                </a>

                <a v-if="survey.status != 'DONE'" @click="deleteById(item)" v-b-tooltip.hover :title="$t('common.delete')">
                  <i class="bx bx-trash-alt text-danger"></i>
                </a>
              </div>
            </td>
            <td>{{ index + 1 }}</td>
            <td>
              <span v-if="item.participant && item.participant.assignee">{{ item.participant.assignee.name | translate }}</span>
            </td>
            <td>
              <span v-if="item.participant && item.participant.title">{{ item.participant.title | translate }}</span>
            </td>
            <td>
              <span v-if="item.participant && item.participant.unit">{{ item.participant.unit | translate }}</span>
            </td>
            <td>
              <span v-if="item.participant && item.participant.contact">{{ item.participant.contact }}</span>
            </td>
            <td>
              <span>{{ item.participant.at | date(true) }}</span>
            </td>
            <td></td>
          </tr>
        </template>
      </tbody>
    </table>
  </div>
</template>

<script>
import organizationInviteMember from "../organization/organization-invite-member.vue";
import Form from "./organization-file-approval-survey-members-form.vue";
export default {
  components: { organizationInviteMember, Form },

  data() {
    return {
      request: {
        options: { page: 1, limit: 15 },
        query: {},
      },
      filterEnabled: false,
      selectedMember: undefined,
      form: {
        members: [],
      },
    };
  },
  async mounted() {
    const id = this.$route.params.id;
    const fileId = this.$route.params.fileId;
    if (fileId) {
      const file = await this.$store.dispatch("fileManager/fetchDetail", fileId);

      this.$store.commit("fileManager/selectedEntity", file);
    }
    if (id) {
      await this.fetchSurveyMembers();
    }
  },
  watch: {},
  computed: {
    memberPagination() {
      return this.$store.getters[`organizationFileApprovalSurvey/memberPagination`];
    },
    file() {
      return this.$store.getters["fileManager/selectedEntity"];
    },
    survey() {
      return this.$store.getters["organizationFileApprovalSurvey/survey"];
    },
    header() {
      // return `${this.file.no} - ${this.name.tr} - Onay Durumu Anket Kullanıcıları Ekranı`;
    },
  },

  methods: {
    goBack() {
      this.$router.push(`/${this.currentProduct ? this.currentProduct.toLowerCase() : "organization"}/file-approval-survey/${this.file?._id}/survey`);
    },
    createSurveyParticipant() {
      this.$root.$emit("bv::toggle::collapse", "sidebar-survey-participant");
    },

    toggleFilter() {
      this.filterEnabled = !this.filterEnabled;
    },
    showModal() {
      this.$root.$emit("bv::show::modal", "invite-member");
    },
    onMemberSelected(member) {
      this.form.members.push(member);
    },
    async fetchSurveyMembers() {
      const id = this.$route.params.id;
      try {
        this.request.query = { ...this.request.query, survey: { value: id, isObject: true } };
        await this.$store.dispatch("organizationFileApprovalSurvey/fetchMembers", this.request);
      } catch (error) {
        this.$handleHttpErrorByStatusCode(error);
      }
    },
    edit(item) {
      this.$store.commit("organizationFileApprovalSurvey/editedMember", item);
      this.$root.$emit("bv::toggle::collapse", "sidebar-survey-participant");
    },
    async deleteById(item) {
      try {
        const ok = await this.confirm(this.$t("alert.approve"));
        if (!ok) {
          return;
        }
        await this.$store.dispatch("organizationFileApprovalSurvey/deleteMember", item._id);
        this.$toast.success(this.$t("common.success"));
        this.fetchSurveyMembers();
      } catch (error) {
        this.$handleHttpErrorByStatusCode(error);
      }
    },
    rightPanelClosed() {
      this.$store.commit(`organizationFileApprovalSurvey/editedMember`, null);
      this.fetchSurveyMembers();
    },
    async save() {},
    async onAccountSearch(value, callback) {
      const response = await this.$store.dispatch(`organizationMember/paginateWith`, {
        pagination: {
          options: { limit: 200 },
          query: { name: { value }, accessable: { value: true, isObject: true } },
        },
        organizationId: this.currentOrganization?._id,
      });
      callback(response.data.docs ?? []);
    },

    onAccountSelect(members) {
      this.form = { ...this.form, members };
    },
  },
};
</script>

<style lang="scss" scoped>
@import url("../entity/organization-entities-view.scss");
</style>
